module.exports = __webpack_public_path__ + "static/1-afc712c3aeca139d7467186c7ae626d1.jpeg";